import { useNavigate } from "react-router-dom";
import "../../styles/studio/common/studio.css";
import PageHeader from "../../components/common/PageHeader";

const Studio = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        title={"Studio"}
        description={"Select a workspace to start your creative journey"}
      />
      <div className="studio-hub-container">
        <div className="studio-options-grid">
          {/* Visualizations Card */}
          <div
            className="hub-option-card viz-theme"
            onClick={() => navigate("/studio/visualizations")}
          >
            <div className="hub-icon">📖</div>
            <h2>Visualizations</h2>
            <p>
              The art of teaching through motion. Combine theory and animation
              to create interactive posts that explain complex ideas.
            </p>
            <button className="hub-btn">View Visualizations</button>
          </div>

          {/* Animations Card */}
          <div
            className="hub-option-card anim-theme"
            onClick={() => navigate("/studio/animations")}
          >
            <div className="hub-icon">✨</div>
            <h2>Animations</h2>
            <p>
              Transform complex theory into beautiful, interactive animations.
            </p>
            <button className="hub-btn">View Animations</button>
          </div>

          {/* Folders Card */}
          <div
            className="hub-option-card viz-theme"
            onClick={() => navigate("/studio/folders")}
          >
            <div className="hub-icon">📁</div>
            <h2>Folders</h2>
            <p>
              Organize your visualizations and animations into folders for easy
              management and structured workflow.
            </p>
            <button className="hub-btn">View Folders</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Studio;
